export const ProxyAssignmentIcon = () => {
  return (
    <span className="h-4 w-4 inline-flex items-center justify-center rounded-full text-xs font-semibold text-white bg-gradient-to-r from-indigo-300 via-rose-300 to-pink-300">
      U
    </span>
  );
};
